var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgCsvSourceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "88.281%",
    x2: "0%",
    y2: "11.719%",
    id: "CsvSourceIcon_svg__[object_Object]a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#596168",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B8B99",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 12a2 2 0 011.732 1H408a1 1 0 110 2l-6.268.001a2 2 0 01-3.464 0L394 15a1 1 0 110-2h4.268A2 2 0 01400 12zm5-5a2 2 0 011.732 1H408a1 1 0 110 2l-1.268.001a2 2 0 01-3.464 0L394 10a1 1 0 110-2h9.268A2 2 0 01405 7zm-6-5a2 2 0 011.732 1H408a1 1 0 110 2l-7.268.001a2 2 0 01-3.464 0L394 5a1 1 0 110-2h3.268A2 2 0 01399 2z",
    transform: "translate(-393 -2)",
    fill: "url(#CsvSourceIcon_svg__[object_Object]a)",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvSourceIcon);
export default ForwardRef;